import {useListView} from '../../providers/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'



const UsersListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>

      {/* begin::Card toolbar */}
      <div className='card-toolbar'>

        {/* begin::Group actions */}
        {selected.length > 0 ? <UsersListGrouping /> : ''}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
